import pl from "./pl";
import en from "./en";
import es from "./es";

export default {
  pl: {
    message: pl
  },
  en: {
    message: en
  },
  es: {
    message: es
  }
};
